// extracted by mini-css-extract-plugin
export default {"AppFooter":"AppFooter_AppFooter__KSawk","footerTxt":"AppFooter_footerTxt__X4q1X","footerNum":"AppFooter_footerNum__q6yo5"};